import HubPage from "@/pages/HubPage";
import { ARCH } from "@/seo/archContent";

export default function ArchitectsPage() {
  return <HubPage id="arch" content={ARCH} metaKey="arhitecti" hero="/images/panouri-hero.jpg" bg="/images/panouri-1.jpg" />;
}
